<template>
  <div class="form-widget-area form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="disabled"
      >
        <template v-if="renderSence === 'edit'">
          <span v-if="!areaInfo && !widget.readOnly" class="cube-input-field cube-input-field--placeholder area-span" @click="handleShowAreaSelect">{{ '点击选择地址' }}</span>
          <span v-else class="area-span" @click="handleShowAreaSelect">{{ areaInfo }}</span>
          <cube-textarea
            ref="textareaInputRef"
            v-if="showAddress"
            :value="textareaValue.name"
            :class="{'cube-textarea-readonly': widget.readOnly}"
            :disabled="disabled"
            :placeholder="!disabled ? '请输入详细地址' : ''"
            :maxlength="200"
            @input="textareaInputEvent"
          ></cube-textarea>
          <!-- <pre v-else-if="showAddress">{{ textareaValue.name }}</pre> -->
        </template>
        
        <span v-if="renderSence === 'read'">{{ value || '-' }}</span>
      </x-proxy-form-item>
      <div v-if="renderSence === 'edit'" class="form-item-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }">
        <x-svg-icon name="x-lib-area" @click.native="handleToMap"></x-svg-icon>
        <!-- <x-svg-icon v-else name="x-lib-clear" @click.native="handleClear"></x-svg-icon> -->
      </div>
    </div>
    <x-area
      ref="xAreaRef"
      @change="handleChange"
    ></x-area>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'

export default {
  name: 'FormWidgetArea',
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  data() {
    return {
      requiredValiDator: (errorMsg) => {
        return (rule, value, callback) => {
          if (!value) {
            return callback(new Error(`${this.widget.label}是必填字段`))
          }
          if (!value.province || !value.province.code || !value.province.name) {
            return callback(new Error(`${this.widget.label}是必填字段`))
          }
          if (!value.city || !value.city.code || !value.city.name) {
            return callback(new Error(`${this.widget.label}是必填字段`))
          }
          if (!value.area || !value.area.code || !value.area.name) {
            return callback(new Error(`${this.widget.label}是必填字段`))
          }
          if (this.showAddress && (!value.address || !value.address.name)) {
            return callback(new Error(`${this.widget.label}是必填字段`))
          }
          return callback()
        }
      }
    }
  },
  computed: {
    disabled() {
      return this.widget.readOnly
    },
    showAddress() {
      return this.widget.areaType === 'AREA_ADDRESS'
    },
    areaInfo() {
      if (!this.formValue) {
        return ''
      }
      const arr = [
        ((this.formValue.province && this.formValue.province.name) || ''),
        ((this.formValue.city && this.formValue.city.name) || ''),
        ((this.formValue.area && this.formValue.area.name) || '')
      ]
      let value = ''
      arr.forEach((item, index) => {
        if (item && index < 2) {
          value = value + item + '-'
        } else {
          value = value + item
        }
      })
      return value
    },
    value() {
      if (this.formValue) {
        if (this.showAddress) {
          return (
            ((this.formValue.province && this.formValue.province.name) || '') +
            ((this.formValue.city && this.formValue.city.name) || '') +
            ((this.formValue.area && this.formValue.area.name) || '') +
            ((this.formValue.address && this.formValue.address.name) || '')
          )
        } else {
          return (
            ((this.formValue.province && this.formValue.province.name) || '') +
            ((this.formValue.city && this.formValue.city.name) || '') +
            ((this.formValue.area && this.formValue.area.name) || '')
          )
        }
      } else {
        return ''
      }
    },
    textareaValue: {
      get() {
        return this.formValue && this.formValue.address || {
          name: ''
        }
      },
      set(value) {
        this.formValue = {
          ...this.formValue,
          address: {
            name: value.name
          }
        }
      }
    }
  },
  watch: {
    'widget.required': {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.widgetRules = [this._validate(this.requiredValiDator())]
        } else {
          this.widgetRules = []
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClear(e) {
      e.preventDefault()
      e.stopPropagation()
      this.formValue = {
        ...this.formValue,
        province: {
          code: '',
          name: ''
        },
        city: {
          code: '',
          name: ''
        },
        area: {
          code: '',
          name: ''
        }
      }
    },
    handleShowAreaSelect() {
      if (!this.widget.readOnly) {
        this.$refs.xAreaRef && this.$refs.xAreaRef.showAsyncPicker()
      }
    },
    handleToMap(e) {
      e.preventDefault()
      e.stopPropagation()
      if (!this.widget.readOnly) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: this.formValue
        })
      }
    },
    textareaInputEvent($event) {
      this.textareaValue = {
        name: $event
      }
      // console.log(this.formValue)
    },
    handleChange(e) {
      this.formValue = {
        ...this.formValue,
        ...e
      }
    }
  }
}
</script>

<style lang="scss" scope>
.form-widget-area {
  .area-span {
    min-height: 1.714rem;
    display: flex;
    align-items: center;
    margin-right: 1.5rem;
  }
  .form-item-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    justify-content: center;
    width: 3.43rem;
    min-height: 5.07rem;
    height: 5.07rem;
    font-size: 0;
    // &.full-height {
    //   min-height: 5.07rem;
    //   height: 5.07rem;
    // }
    .x-svg-icon {
      color: #B2B2B2;
    }
  }
  .form-item-content {
    position: relative;
    .cube-textarea-wrapper {
      height: 100%;
      min-height: 3.857rem;
      max-height: 19.571rem;
      border-top: 1px solid #F5F7FA;
      margin-top: 0.875rem;
      padding-top: 0.857rem;
      &.cube-textarea-readonly {
        .cube-textarea {
          color: $--app-notice-color;
        }
      }
    }
    .cube-textarea-wrapper::after {
      border: 0;
    }
    .cube-textarea {
      border: 0;
      font-size: $--app-title-font-size;
      color: $--app-base-font-color;
      padding: 0;
      margin-bottom: 0.429rem;
      min-height: 3.857rem;
      max-height: 19.571rem;
    }
    .cube-textarea_expanded {
      min-height: 3.857rem;
      max-height: 19.571rem;
    }
    .cube-textarea-indicator {
      display: none !important;
    }
    .cube-textarea_active::after {
      border: 0 !important;
    }
    .readonly-background {
      background-color: $--app-form-readonly-bgColor !important;

      .cube-textarea {
        background-color: $--app-form-readonly-bgColor !important;
        color: $--app-base-font-color !important;
      }
      textarea:disabled {
        opacity: 1 !important;
      }
    }
  }
}
</style>